import { render } from "./ResultStatus.vue?vue&type=template&id=d0e57ac8&scoped=true"
import script from "./ResultStatus.vue?vue&type=script&lang=js"
export * from "./ResultStatus.vue?vue&type=script&lang=js"

import "./ResultStatus.vue?vue&type=style&index=0&id=d0e57ac8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0e57ac8"]])

export default __exports__